<div class="has-pos-rel" #searchBarRef>
  <div class="search-bar-container is-flex">
    <div [class.hidden]="!showSearchResults" class="has-no-pad-sides" *ngIf="showBackButton">
      <b><i class="material-icons md-36 back" (click)="onGoToPreviousScreenClick($event)">keyboard_arrow_left</i></b>
    </div>
    <div class="search-input-wrapper flex-one"  [class.no-search-results]="!showSearchResults">
      <form (ngSubmit)="onSubmit()" [formGroup]="searchForm">
        <app-input [focus]="focus" (onFocus)="onSearchInputClick($event)" (onBlur)="onLoseFocus()"
                   [parentFormGroup]="searchForm" [formControl]="searchForm.controls['searchInput']"
                   [placeholder]="placeholder || ('searchBar.' + (isNearMe ? 'nearMePlaceHolder' : 'inputPlaceholder') | translate)"
                   [ariaTranslateTag]="'searchBar.aria.' + (isNearMe ? 'nearMePlaceHolder' : 'inputPlaceholder')">
          <i *ngIf="isNearMe" class="place material-icons has-pos-abs">place</i>
          <i class="clear-ic material-icons md-18 has-pos-abs" *ngIf="showSearchResults && searchInput" (click)="onClearInput($event)">highlight_off</i>
        </app-input>
      </form>
    </div>
  </div>

  <div [class.hidden]="!showSearchResults">
    <app-search-results *ngIf="showSearchResults"
                        [locationResults]="locationResults"
                        [mlsMatchResults]="mlsMatchResults"
                        (onBlur)="onLoseFocus()"
                        (favouriteClick)="onFavouriteClick($event)"
                        (selectResult)="onSelectResult($event)"
                        [isSearchingForResults]="isSearching"
                        [searchInput]="searchInput"
                        [recentSearches]="recentSearches"
                        [showButtons]="showAdditionalActionsButtons">
    </app-search-results>
  </div>
</div>


